import useInput from "./useInput";
import useSelect from "./useSelect";

const exports = {
    useInput,
    useSelect,
};

export default exports;
